export default {"src":"/_next/static/media/Group-25843.c0b95b8a.svg","height":104,"width":104};